import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

Alpine.data('kasirInvitationThemeVersions', () => ({
  loading: true,
  items: [],

  init() {
    this.load();
  },

  async load() {
    this.loading = true;
    try {
      const { data } = await axios.get('/api/v1/kasir/engagement/invitation-theme/versions');
      this.items = data.data || [];
    } catch (e) {
      window.toast?.(e.response?.data?.message || 'Gagal memuat versi.', 'error');
      this.items = [];
    } finally {
      this.loading = false;
    }
  },
}));
